import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class EnvironmentService {
  private version!: string;
  private title!: string;
  private authUrl!: string;
  private authClientId!: string;
  private region!: string;
  private graphQLUrl!: string;
  private noTurnoverNotesBefore!: Date;
  private fieldVisionUrl!: string;
  private publicFunctionApiKey!: string;

  constructor() {
    this.getSettings = this.getSettings.bind(this);
  }

  getVersion() {
    return this.version;
  }

  getTitle() {
    return this.title;
  }

  getAuthUrl() {
    return this.authUrl;
  }

  getAuthClientId() {
    return this.authClientId;
  }

  getRegion() {
    return this.region;
  }

  getGraphQLURL() {
    return this.graphQLUrl;
  }

  getSettings() {
    const env = environment;

    this.version = env.version;
    this.title = env.title;
    this.authUrl = env.oktaAuthIssuerURL;
    this.authClientId = env.oktaClientId;
    this.region = env.region;
    this.graphQLUrl = env.graphQLUrl;
    this.noTurnoverNotesBefore = env.no_turnover_controller_notes_before;
    this.fieldVisionUrl = env.fieldVisionUrl;
    this.publicFunctionApiKey = env.publicFunctionApiKey;
  }

  getNoTurnoverNotesBefore() {
    return this.noTurnoverNotesBefore;
  }

  getFieldVisionUrl() {
    return this.fieldVisionUrl;
  }

  getpublicFunctionApiKey() {
    return this.publicFunctionApiKey;
  }
}
